module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "c012"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }), _c('b', [_vm._v("1792")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter0"
  }, [_vm._v("Optical Telegraph")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent_line"
  }, [_c('b', [_vm._v("Claude Chappe")]), _vm._v(" (1763–1805)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("People had used signal fires, torches, and smoke signals since ancient times to send messages rapidly over long distances. The ancient Athenians used flashes of sunlight from their shields to send messages from ship to shore. The Romans coded flags to send messages over a distance—a practice that the British Navy also employed as early as the 14th century.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1790, an out-of-work French engineer named Claude Chappe started a project with his brothers to develop a practical system for sending messages quickly over the French countryside. The idea was to set up a series of towers constructed on hills, with each tower in view of the next. Each tower would be equipped with a device that had big, movable arms and a telescope, so that the position of the arms could be determined and then relayed to the next tower. An operator in the first tower would move the arms into different positions, each position signaling a letter, and the operator in the second tower would write it down—essentially sending letters over distance ("), _c('i', [_vm._v("tele-graph")]), _vm._v(") with light. A second telescope would allow for messages to be conveyed in the opposite direction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After successfully sending a message nearly 9 miles (14 kilometers) on March 2, 1791, Claude and his younger brothers, Pierre François (1765–1834), René (1769–1854), and Abraham (1773–1849), moved to Paris to continue the experiments and drum up support from the new government. Their older brother, Ignace Chappe (1760–1829), was a member of the revolutionary Legislative Assembly, which probably helped somewhat. Soon the brothers were authorized by the Assembly to construct three stations as a test. That test went well, and in 1793 the Assembly decided to replace its system of couriers with optical telegraph lines. Claude Chappe was appointed lieutenant of engineering for the construction of a telegraph line between Paris and Lille, under the control of the Ministry of War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first practical demonstration of the telegraph came on August 30, 1794, when the Assembly learned that its army in Condé-sur-l’Escaut had been victorious. That message was transmitted in about half an hour. In the following years, telegraph lines were built across France, connecting all of the major cities. At its height, the system had 534 stations covering more than 3,000 miles (5,000 kilometers). Not surprisingly, Napoléon Bonaparte made heavy use of the technology during his conquest of Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('b', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c017_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fax Machine Patented (1843)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('i', [_vm._v("An artist’s impression of Claude Chappe, demonstrating his aerial telegraph semaphore system, from the Paris newspaper")]), _vm._v(" Le Petit Journal, "), _c('i', [_vm._v("1901.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/39-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-405eeb14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926221_epub_c012_r1.vue
// module id = 108
// module chunks = 0